import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageWSL6 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "Sarina Wiegman Wins Coach Award",
            author: "footballgirl",
            date: "January, 2026",
            image: "images/wsl/6a.jpg",
            content: `<p><b>England</b> manager <b>Sarina Wiegman</b> has been awarded the <b>Coach of the Year</b> award following another successful year with the <b>Lionesses</b>.</p>

<p>This recognition comes as part of a remarkable run of accolades for the Dutch coach in late 2025 and early 2026, largely driven by her leadership in guiding <b>England</b> to back-to-back <b>UEFA Women's EURO</b> titles. After their historic home victory in 2022, Wiegman masterminded a successful title defence at <b>UEFA Women's EURO 2025</b> in Switzerland, where the <b>Lionesses</b> defeated Spain in a dramatic final to secure consecutive European Championships—a first for any <b>England</b> football team on foreign soil.</p>

<p>In December 2025, Wiegman was named <b>The Best FIFA Women's Coach</b> for an unprecedented fifth time at <b>The Best FIFA Football Awards</b> in Doha. She beat out strong competition including Sonia Bompastor (Chelsea), Renee Slegers (Arsenal), Seb Hines (Orlando Pride), and Jonatan Giraldez (OL Lyonnes). This victory extended her record as the most decorated recipient of the award in the women's category, highlighting her tactical acumen and ability to deliver under pressure on the international stage.</p>

<p>She also claimed the women's coach of the year honor at the <b>2025 Ballon d'Or</b> awards (the <b>Johan Cruyff Trophy</b>) earlier in September 2025. Later that month, Wiegman made history in her home country by becoming the first woman to win <b>Coach of the Year</b> at the <b>2025 NOC*NSF Sports Gala</b> in the Netherlands.</p>

<p>Domestically, she was named <b>BBC Sports Personality Coach of the Year</b> for a second time in December 2025, following the <b>Lionesses'</b> EURO triumph. In early 2026, Wiegman received further recognition with the <b>Editor’s Choice Award</b> at <b>The Sunday Times Sportswomen of the Year Awards 2025</b> in February, alongside <b>Lionesses</b> player Michelle Agyemang, who picked up the <b>Young Sports Personality</b> honor.</p>

<p>Adding to her personal honors, Wiegman was awarded an honorary <b>DBE</b> (Dame Commander of the Order of the British Empire) in the <b>King's New Year Honours</b> list for 2026, a rare distinction for a foreign national recognizing her contributions to women's football in the UK and international achievement.</p>

<p>Wiegman's ongoing success has not only elevated the <b>Lionesses</b> to new heights but also inspired greater investment and visibility in the women's game globally. Her tactical discipline, player development focus, and calm leadership continue to set benchmarks in the sport.</p> <p><b>英格兰</b>主教练<b>萨里娜·维格曼</b>因带领<b>狮子女</b>队又取得成功的一年而荣获<b>年度最佳教练</b>奖。</p>

<p>这一认可源于这位荷兰教练在2025年底至2026年初取得的惊人一系列荣誉，主要得益于她带领<b>英格兰</b>队连续夺得<b>欧洲女子足球锦标赛</b>冠军。在2022年本土历史性夺冠后，维格曼在2025年瑞士举办的<b>欧洲女子足球锦标赛</b>上成功卫冕，<b>狮子女</b>队在决赛中戏剧性地击败西班牙，实现了连续两届欧洲冠军——这是任何<b>英格兰</b>足球队在国外土地上首次做到这一点。</p>

<p>2025年12月，维格曼在多哈举行的<b>The Best FIFA足球奖</b>颁奖典礼上第5次荣获<b>最佳女子足球教练</b>，创下历史纪录。她击败了包括索尼娅·邦帕斯托（切尔西）、蕾妮·斯莱格斯（阿森纳）、塞布·海因斯（奥兰多荣耀）和乔纳坦·吉拉德斯（里昂女子）等强劲竞争对手。这一胜利进一步巩固了她在女子类别中最具荣誉得主的纪录，凸显了她在国际舞台上的战术智慧和高压下交付能力。</p>

<p>她还在2025年9月的<b>2025年金球奖</b>（约翰·克鲁伊夫奖杯）中荣获女子年度最佳教练。随后当月，维格曼在荷兰本土创造了历史，成为首位在<b>2025年NOC*NSF体育盛典</b>上获得<b>年度最佳教练</b>的女性。</p>

<p>在国内，她于2025年12月第二次荣获<b>BBC体育人格年度最佳教练</b>，这是继<b>狮子女</b>队欧洲杯胜利后的又一肯定。2026年初，维格曼在2月的<b>2025年星期日泰晤士报年度最佳女运动员奖</b>中获得<b>编辑选择奖</b>，与<b>狮子女</b>球员米歇尔·阿杰曼一同获奖，后者荣获<b>年度年轻体育人格</b>。</p>

<p>此外，维格曼在2026年国王新年荣誉榜中获颁荣誉<b>DBE</b>（大英帝国司令勋章女性版），这是外国国民极少获得的殊荣，以表彰她对英国女子足球的贡献以及国际成就。</p>

<p>维格曼的持续成功不仅将<b>狮子女</b>队提升到新高度，还激发了全球对女子足球的更大投资和关注度。她的战术纪律、球员发展重点以及冷静领导力继续为这项运动树立标杆。</p>`,
            tags: ["England", "Sarina Wiegman", "Awards"],
            navIndices: { prev: 'wsl-5', next: 'wsl-7' }
        });
    }

    init() {
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to WSL
            
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
`;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'wslnews' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) { leagueLogo.src = '/images/league_wsl.png'; leagueLogo.alt = 'WSL'; }
    }
}